export const getAnalysisCategories = state => state.analysisCategories.data;
export const getAnalysisCategoriesLoading = state =>
  state.analysisCategories.loading;
